import { render, staticRenderFns } from "./RequestWidget.vue?vue&type=template&id=195fbfe7&scoped=true&lang=pug&"
import script from "./RequestWidget.vue?vue&type=script&lang=js&"
export * from "./RequestWidget.vue?vue&type=script&lang=js&"
import style0 from "./RequestWidget.vue?vue&type=style&index=0&id=195fbfe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195fbfe7",
  null
  
)

export default component.exports